import {
    AllEvents,
    queries,
    ConfigurationContext,
    ElectionDefinition,
    useFeature,
} from '@news-mono/web-common'
import React, { useContext } from 'react'
import { useQuery } from '@tanstack/react-query'
import { ElectionText } from '../components'
import {
    StyledElectionLink,
    StyledTitleContainer,
} from '../FullElectorateWidget/FullElectorateWidget.styled'
import { CustomPageSharing } from '../../../buttons/SharingCustomPage/CustomPageSharing'
import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../../__styling'
import { ElectionFilterContext } from '../../../contexts'

export interface TNElectorateHeaderProps {
    electionDefinition: ElectionDefinition
    onEvent: (event: AllEvents) => void
}

export const TNElectorateHeader = ({
    onEvent,
    electionDefinition,
}: TNElectorateHeaderProps): JSX.Element => {
    const config = useContext(ConfigurationContext)
    const result = useQuery(
        queries['election-api'].definition({
            initialDefinition: electionDefinition,
            electionAPI: config.electionApi,
            caller: config.apiCallerHeader,
        }),
    )
    //find out the current sort method
    const { sort } = useContext(ElectionFilterContext)
    const isLatestSort = sort.value.paramName === 'latest'
    
    // Keeping this coded to federal election. Possible to expand to other elections
    const isLivePrefix = useFeature('federal-election-live-title-prefix')

    return (
        <StyledTitleContainer>
            <StyledElectorateTitle>
                {isLivePrefix ? 'Live Electorate Results' : 'Electorate Results'}
            </StyledElectorateTitle>
            <ElectionText>
                {'Live tracking of electorates as they are called.'}
            </ElectionText>
            <CustomPageSharing
                text={`${
                    result.data &&
                    result.data.electionData.config?.electionTitle
                } electorate results | The Nightly`}
                shareOptions={[
                    'facebook',
                    'linkedin',
                    'twitter',
                    'email_tn',
                    'clipboard',
                ]}
                loading={false}
                onEvent={onEvent}
            />
            {isLatestSort && (
                <ElectionText>
                    <StyledElectionLink
                        href={
                            '/politics/federal-election-2025/federal-election-2025-the-key-seats-to-watch-as-australia-head-to-the-polls-c-17931811'
                        }
                    >
                        Read more about the key seats
                    </StyledElectionLink>{' '}
                    set to shape the outcome of this election.
                </ElectionText>
            )}
        </StyledTitleContainer>
    )
}

export const StyledElectorateTitle = styled('h1')({
    fontSize: calcRem(40),
    fontWeight: 700,
    lineHeight: calcRem(48),
    letterSpacing: '-4%',
    margin: 0,
    [breakpoint('lg')]: {
        fontSize: calcRem(51),
        lineHeight: calcRem(56),
    },
})
